/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeterCreate } from '../models/MeterCreate';
import type { MeterCreateBulk } from '../models/MeterCreateBulk';
import type { MeterDetails } from '../models/MeterDetails';
import type { MeterUpdate } from '../models/MeterUpdate';
import type { PagedItems } from '../models/PagedItems';
import type { PagedMeters } from '../models/PagedMeters';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class MetersVService {

    /**
     * @param serviceAddressId
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async metersVGetAll(
        serviceAddressId: string,
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param requestBody
     * @returns MeterDetails OK
     * @throws ApiError
     */
    public static async metersVGetExport(
        serviceAddressId: string,
        requestBody?: PagingQuery,
    ): Promise<MeterDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param districtId
     * @param requestBody
     * @returns PagedMeters OK
     * @throws ApiError
     */
    public static async metersVGetAllByDistrict(
        serviceAddressId: string,
        districtId?: string,
        requestBody?: PagingQuery,
    ): Promise<PagedMeters> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/get/district`,
            query: {
                'districtId': districtId,
            },
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param districtId
     * @param requestBody
     * @returns MeterDetails OK
     * @throws ApiError
     */
    public static async metersVGetExportByDistrict(
        serviceAddressId: string,
        districtId?: string,
        requestBody?: PagingQuery,
    ): Promise<MeterDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/export/district`,
            query: {
                'districtId': districtId,
            },
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param requestBody
     * @returns MeterDetails OK
     * @throws ApiError
     */
    public static async metersVGetAll1(
        serviceAddressId: string,
        requestBody?: Array<string>,
    ): Promise<Array<MeterDetails>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/get/ids`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param meterId
     * @param requestBody
     * @returns MeterDetails OK
     * @throws ApiError
     */
    public static async metersVUpdateMeter(
        serviceAddressId: string,
        meterId: string,
        requestBody?: MeterUpdate,
    ): Promise<MeterDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/${meterId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param meterId
     * @returns MeterDetails OK
     * @throws ApiError
     */
    public static async metersVGetById(
        serviceAddressId: string,
        meterId: string,
    ): Promise<MeterDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/${meterId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param requestBody
     * @returns MeterDetails Created
     * @throws ApiError
     */
    public static async metersVCreateAllMeters(
        serviceAddressId: string,
        requestBody?: Array<MeterCreateBulk>,
    ): Promise<Array<MeterDetails>> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/bulk`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param requestBody
     * @returns MeterDetails Created
     * @throws ApiError
     */
    public static async metersVCreate(
        serviceAddressId: string,
        requestBody?: MeterCreate,
    ): Promise<MeterDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}